import { EmployeeStatus } from 'components/employee-analytics/analytic-item/EmployeeStatus'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_EMPLOYEE_ANALYTICS } from 'services/apiEmployeeAnalytics'

const INITIAL_FILTER = {
    company_ids: [],
    department_ids: [],
    division_ids: [],
    sub_division_ids: [],
}

const EmployeeStatusContainer = () => {
    const { fetching: getEmployeeStatus, isLoading } = useFetch(API_EMPLOYEE_ANALYTICS.EMPLOYEE_STATUS)
    const [employeeData, setEmployeeData] = useState({})
    const [active, setActive] = useState(null)
    const [filter, setFilter] = useState(INITIAL_FILTER)

    const styleBar = (key) => {
        switch (key) {
            case 'permanent':
                return { color: 'bg-sky-500', light: 'hover:bg-sky-400' }
            case 'contract':
                return { color: 'bg-orange-400', light: 'hover:bg-orange-300' }
            case 'probation':
                return { color: 'bg-indigo-500', light: 'hover:bg-indigo-400' }
            case 'outsourcing':
                return { color: 'bg-rose-500', light: 'hover:bg-rose-400' }
            case 'service_agreement':
                return { color: 'bg-lime-500', light: 'hover:bg-lime-400' }
            case 'flip':
                return { color: 'bg-violet-500', light: 'hover:bg-violet-400' }
            default:
                return { color: 'bg-slate-500', light: 'hover:bg-slate-400' }
        }
    }

    useEffect(() => {
        ;(async () => {
            const employeeStatus = await getEmployeeStatus(filter)
            const newData = {
                ...employeeStatus?.data,
                detail: Object.entries(employeeStatus?.data?.detail).map(([key, value]) => ({
                    ...value,
                    ...styleBar(key),
                    label: key?.replace('_', ' '),
                })),
            }

            setEmployeeData(newData)
        })()
    }, [filter])

    const onSubmitFilter = (newFilter) => {
        if (JSON.stringify(filter) !== JSON.stringify(newFilter)) {
            setFilter(newFilter)
        }
    }

    const props = {
        active,
        setActive,
        data: employeeData,
        isLoading,
        filter,
        onSubmitFilter,
    }

    return <EmployeeStatus {...props} />
}

export default EmployeeStatusContainer
